export default __webpack_public_path__ + "static/media/smedetoften-tenancy-03.6662bcd2.jpg";